<div class="row">
    <div class="col px-0 pt-2">
        <h5 class="weekDayHeader">{{dateObj.date | date : 'EEEE'}}</h5>
        <span class="dateHeader">{{dateObj.date | date:'MM/dd/yyyy'}}</span>
        <div class="col-12" *ngFor="let event of dateObj.events">
            <app-calendar-event [event]="event" class="m-0" (eventSelected)="eventSelected($event)"></app-calendar-event>
        </div>
    </div>
</div>

